import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/authentication/authContext';
import { canAccessStaffPage } from '../services/accessManagement/accessManagement';

export function StaffManagerRoute({ children }: { children: JSX.Element }) {
  const { user, backendUser, loading } = useAuth();

  if (loading) {
    return <div>Loading…</div>;
  }
  return user && canAccessStaffPage(backendUser) ? children : <Navigate to="/" replace />;
}
